import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Merges Tailwind class strings, resolving conflicts. The canonical
// shadcn helper. Used by every primitive in src/components/ui/.
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
